import { Controller } from '@hotwired/stimulus';
import { Tooltip } from 'bootstrap';

// Connects to data-controller="favorite"
export default class extends Controller {
  static values = {
    url: String,
    favorite: Boolean
  };

  connect() {
    this.loading = false;
    this.tooltip = new Tooltip( this.element );
  }

  disconnect() {
    this.disposeTooltip();
  }

  toggle( event ){
    event.preventDefault();
    event.stopPropagation();

    if( this.loading ) return;

    const csrfToken = document.querySelector( "meta[name='csrf-token']" ).content;

    this.loading = true;
    this.disposeTooltip();
    this.showSpinner();

    fetch( this.urlValue, {
      method: 'PATCH',
      credentials: 'same-origin',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': csrfToken
      }
    } )
    .then( res => {
      if( !res.ok ) throw new Error( 'Request failed' );
      return res.text();
    } )
    .then( html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString( html, 'text/html' );

      const labId = this.element.dataset.labId;
      const template = doc.querySelector( 'turbo-stream template' );

      let isFav = false;

      if( template ){
        const content = template.content;
        isFav = content.querySelector( `#lab_${labId}` ) !== null;
      }

      this.favoriteValue = isFav;

      // Compute URL
      const url = new URL( this.urlValue, window.location.origin );
      url.searchParams.set( 'favorite', !isFav );
      const nextUrl = url.pathname + url.search;

      this.updateIcon( nextUrl );
      window.Turbo.renderStreamMessage( html );
    } )
    .catch( error => {
      window.toastr.error( 'Unknown error has occurred' );
      console.error( 'Error:', error );
      // Restore to current state
      const url = new URL( this.urlValue, window.location.origin );
      url.searchParams.set( 'favorite', !this.favoriteValue );
      this.updateIcon( url.pathname + url.search );
    } )
    .finally( () => {
      this.loading = false;
    } );
  }

  showSpinner() {
    this.element.style.pointerEvents = 'none';
    this.element.innerHTML = `<span class="spinner-border spinner-border-sm text-primary" role="status"></span>`;
  }

  disposeTooltip() {
    const tooltip = Tooltip.getInstance( this.element );
    if( tooltip ){
      tooltip.dispose();
    }
  }

  updateIcon( nextUrl ){
    const isFav = this.favoriteValue;
    const labId = this.element.dataset.labId;

    const elements = document.querySelectorAll(
      `[data-controller="favorite"][data-lab-id="${labId}"]`
    );

    elements.forEach( el => {
      el.style.pointerEvents = '';
      el.innerHTML = isFav
        ? '<i class="fa-solid fa-star text-warning"></i>'
        : '<i class="fa-regular fa-star text-muted"></i>';

      const title = isFav
        ? 'Remove from favorites'
        : 'Add to favorites';

      el.setAttribute( 'data-bs-title', title );
      el.setAttribute( 'data-bs-toggle', 'tooltip' );
      el.setAttribute( 'data-bs-placement', 'left' );
      el.dataset.favoriteUrlValue = nextUrl;

      el.dataset.favoriteFavoriteValue = isFav;

      const tooltip = Tooltip.getInstance( el );
      if( tooltip ) tooltip.dispose();

      new Tooltip( el );
    } );

    this.urlValue = nextUrl;
  }
}
